import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookie_consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof localStorage === "undefined") return;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, []);

  function handleChoice(choice: "accepted" | "declined") {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
    // Reload on accept so analytics scripts can initialize with consent
    if (choice === "accepted") {
      window.location.reload();
    }
  }

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#141414",
        borderTop: "1px solid #6366f1",
        fontFamily: "'DM Sans', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "14px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <p style={{ color: "#a1a1aa", fontSize: 14, margin: 0, lineHeight: 1.5, flex: 1, minWidth: 240 }}>
          We use cookies for authentication and analytics.{" "}
          See our{" "}
          <Link to="/privacy" style={{ color: "#6366f1", textDecoration: "underline" }}>
            Privacy Policy
          </Link>.
        </p>
        <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
          <button
            onClick={() => handleChoice("declined")}
            style={{
              padding: "8px 18px",
              fontSize: 13,
              fontWeight: 500,
              fontFamily: "'DM Sans', system-ui, sans-serif",
              borderRadius: 6,
              border: "1px solid #333",
              background: "transparent",
              color: "#a1a1aa",
              cursor: "pointer",
            }}
          >
            Decline
          </button>
          <button
            onClick={() => handleChoice("accepted")}
            style={{
              padding: "8px 18px",
              fontSize: 13,
              fontWeight: 500,
              fontFamily: "'DM Sans', system-ui, sans-serif",
              borderRadius: 6,
              border: "none",
              background: "#6366f1",
              color: "#ffffff",
              cursor: "pointer",
            }}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
